import { Label } from '@components/ui/label';
import { RadioGroup, RadioGroupItem } from '@components/ui/radio-group';
import {
  type DataSourceOption,
  SOURCE_INFO_MAP
} from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = {
  id: string;
  dataSource: DataSourceOption;
  onDataSourceChange: (source: DataSourceOption) => void;

  possibleSources?: DataSourceOption[];
};

export const SourceSelector = observer((props: Props) => {
  const possibleSources = props.possibleSources ?? ['normalSource', 'database'];
  return (
    <>
      <Label>Data source</Label>
      <RadioGroup
        onValueChange={props.onDataSourceChange}
        value={props.dataSource}
      >
        {possibleSources.map(selectedSource => {
          const { value, name } = SOURCE_INFO_MAP[selectedSource];
          return (
            <div className="flex items-center space-x-2" key={value}>
              <RadioGroupItem id={value + props.id} value={value} />
              <Label
                className="cursor-pointer font-normal"
                htmlFor={value + props.id}
              >
                {name}
              </Label>
            </div>
          );
        })}
      </RadioGroup>
    </>
  );
});
